<template>
  <div class="bg-light pagination-table p-3">
    <nav aria-label="Page navigation"
         class="d-flex align-items-center">
      <p class="text-muted small mb-0">Mostrando</p>
      <ul class="pagination mb-0 mx-2">
        <li class="page-item">
          <a class="page-link" href="#" aria-label="Previous">
            <span class="far fa-angle-left"></span>
          </a>
        </li>
        <li class="page-item">
          <a class="page-link" href="#">{{per_page}}</a>
        </li>
        <li class="page-item">
          <a class="page-link" href="#" aria-label="Next" >
            <span  class="far fa-angle-right"></span>
          </a>
        </li>
      </ul>
      <p class="text-muted small mb-0">resultados</p>
    </nav>
    <nav aria-label="Page navigation" class="d-flex align-items-center">
      <ul class="pagination mb-0 mr-1">
        <li class="page-item">
          <a class="page-link" :href="first_page_url" aria-label="Previous">
            <span  class="far fa-angle-double-left"></span>
          </a>
        </li>
      </ul>
      <ul class="pagination mb-0">
        <li class="page-item">
          <a class="page-link" :href="prev_page_url" aria-label="Previous">
            <span  class="far fa-angle-left"></span>
          </a>
        </li>
        <li class="page-item">
          <a class="page-link" href="#">
            {{current_page}}
            <small>de</small>
            {{last_page}}
          </a>
        </li>
        <li class="page-item">
          <a class="page-link" :href="next_page_url" aria-label="Next">
            <span  class="far fa-angle-right"></span>
          </a>
        </li>
      </ul>
      <ul class="pagination mb-0 ml-1">
        <li class="page-item">
          <a class="page-link" :href="last_page_url" aria-label="Previous">
            <span  class="far fa-angle-double-right"></span>
          </a>
        </li>
      </ul>
    </nav>
    <p class="text-muted small mb-0">Mostrando {{data.length}} - {{per_page}} de {{total}} resultados </p>
  </div>
</template>
<script>
  export default {
    name: "pagination",
    props: ['pagination'],
    data: () => ({
      data: [],
      current_page: '',
      first_page_url: '',
      from: '',
      last_page: '',
      last_page_url: '',
      next_page_url: '',
      path: '',
      per_page: '',
      prev_page_url: '',
      to: '',
      total: '',
    }),
    mounted() {
      if (this.pagination) {
        const pagination = JSON.parse(this.pagination);
        Object.keys(pagination).forEach(key => {
          if (key.includes("url") && pagination[key]) {
            const url = new URL(pagination[key]);
            this[key] = `${window.location.pathname}${url.search}`;
          } else {
            this[key] = pagination[key]
          }
        });
      }
    }
  }
</script>
